<div class="tw-size-full">
  <canvas #chartCanvas></canvas>
</div>
